var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoLenders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2751 23.9748C38.3323 14.9863 32.7134 6.03203 23.7249 3.97485C14.7363 1.91767 5.78203 7.53663 3.72485 16.5251C1.66767 25.5137 7.28663 34.468 16.2751 36.5251C25.2637 38.5823 34.218 32.9634 36.2751 23.9748Z",
    stroke: "white",
    strokeWidth: 6.5947,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2751 23.9748C38.3323 14.9863 32.7134 6.03203 23.7249 3.97485C14.7363 1.91767 5.78203 7.53663 3.72485 16.5251C1.66767 25.5137 7.28663 34.468 16.2751 36.5251C25.2637 38.5823 34.218 32.9634 36.2751 23.9748Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.7778V24.7546C11 26.2888 12.2437 27.5324 13.7778 27.5324H20.6556C20.1105 26.6429 19.7963 25.5966 19.7963 24.4769C19.7963 21.2424 22.4183 18.6204 25.6528 18.6204C26.7052 18.6204 27.6928 18.898 28.5463 19.3839V16.5139C28.5463 14.9798 27.3026 13.7361 25.7685 13.7361H21.0539C20.7439 13.7361 20.4528 13.587 20.2717 13.3355C19.668 12.497 18.6978 12 17.6646 12H13.7778C12.2437 12 11 13.2437 11 14.7778ZM26.0694 27.787C27.6675 27.787 28.963 26.4916 28.963 24.8935C28.963 24.3818 28.8301 23.9011 28.597 23.484L24.9095 27.5452C25.2646 27.7007 25.6569 27.787 26.0694 27.787ZM27.0412 22.1672L23.4493 26.123C23.274 25.7498 23.1759 25.3331 23.1759 24.8935C23.1759 23.2955 24.4714 22 26.0694 22C26.4103 22 26.7375 22.059 27.0412 22.1672ZM26.0694 29.8241C28.7925 29.8241 31 27.6166 31 24.8935C31 22.1704 28.7925 19.963 26.0694 19.963C23.3464 19.963 21.1389 22.1704 21.1389 24.8935C21.1389 27.6166 23.3464 29.8241 26.0694 29.8241Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLenders);
export default __webpack_public_path__ + "static/media/NoLenders.d267377367cdf5be33b1833ce5a77c9d.svg";
export { ForwardRef as ReactComponent };